// UI 組件統一導出 - 解決大小寫兼容性問題
// 統一使用小寫版本，避免 Windows 文件系統問題
export { Button, buttonVariants } from './button'

// 其他 UI 組件 - 使用命名導出而非 default 導出
export { Alert, AlertDescription } from './alert'
export { Badge } from './badge'
export { Input } from './input'
export { Label } from './label'
export { Progress } from './progress'
export { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from './card'
export { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select'
export { SimpleSelect } from './simpleSelect'
export { Switch } from './switch'
export { Textarea } from './textarea'

// 添加 Dialog 相關組件的導出
export { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogDescription, 
  DialogFooter 
} from './dialog'

// 添加 Loading 組件的導出
export { PageLoading, SectionLoading } from './loading-spinner'

// 添加 Tabs 組件的導出
export { Tabs, TabsList, TabsTrigger, TabsContent } from './tabs'

// 添加語音播放按鈕組件的導出
export { AudioPlayButton } from './AudioPlayButton'
